import React, { useState } from 'react';
import Button from "@material-ui/core/Button/Button";
import QuizCard from "../QuizCard/quizCard";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";

/**
 * Quiz list section for web.
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizListSection(props) {
    const [ viewAll, setViewAll ] = useState(false);
    const { quizSectionList, sectionName, hideViewMore, showVertical } = props;
    const t = useTranslations();

    function toggle() {
        setViewAll(!viewAll);
        reactGaEvent("Quiz", "View More");
    }

    return (
        <div>
            <div className={'card-view ' + (viewAll ? 'card-less' : '') + (hideViewMore ? 'saved-quiz-view' : '')}>
                <div className="card-list-view">
                    <h4 className="section-name-head">{t(sectionName)}</h4>
                    <div className={"flexBox-container " + (showVertical ? 'saved-quiz-container' : '')}>
                        {
                            quizSectionList.map((data, key) => {
                                return (
                                    <React.Fragment key={key}>
                                        <QuizCard quizData={data} t={t}/>
                                    </React.Fragment>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
            {
                !hideViewMore && quizSectionList && quizSectionList.length > 4 ?
                    <div
                        className={'view-more-section ' + (viewAll ? 'view-less-section' : '')}>
                        <Button className="view-more-btn"
                                onClick={toggle}>{t('view_more')} <i
                            className="fa fa-angle-down"/></Button>
                        <Button className="view-less-btn"
                                onClick={toggle}>{t('view_less')} <i
                            className="fa fa-angle-up"/></Button>
                    </div> : null
            }
        </div>
    );
}

export default QuizListSection;
